import {Dispatch} from 'redux';
import {AccountAPI} from "../services/api/Api";
import {AppStateType} from "../services/rootReducer";

const GET_USER_PREFERENCES_START = 'ChangePreferences/GET_USER_PREFERENCES_START';
const GET_USER_PREFERENCES_SUCCESS = 'ChangePreferences/GET_USER_PREFERENCES_SUCCESS';
const ADD_ACTIVE_TASTES_ID = 'ChangePreferences/ADD_ACTIVE_TASTES_ID';
const REMOVE_ACTIVE_TASTES_ID = 'ChangePreferences/REMOVE_ACTIVE_TASTES_ID';
const SET_ACTIVE_HARDNESS = 'ChangePreferences/SET_ACTIVE_HARDNESS';
const REMOVE_ACTIVE_HARDNESS = 'ChangePreferences/REMOVE_ACTIVE_HARDNESS';
const ADD_ACTIVE_BRANDS_ID = 'ChangePreferences/ADD_ACTIVE_BRANDS_ID';
const REMOVE_ACTIVE_BRANDS_ID = 'ChangePreferences/REMOVE_ACTIVE_BRANDS_ID';
const SET_LOADING_TRUE = 'ChangePreferences/SET_LOADING_TRUE';

interface IChangePreferencesState {
    tastes: Array<object> | null,
    brands: Array<object> | null,
    isLoading: boolean | null,
    activeTastesId: Array<number>,
    activeHardnessId: number | null,
    activeBrandsId: Array<number>
}

interface IChangePreferencesAction {
    type: string,
    payload: any
}

const inititalState: IChangePreferencesState = {
    tastes: null,
    brands: null,
    isLoading: true,
    activeTastesId: [],
    activeHardnessId: null,
    activeBrandsId: []
};

const addActiveTastesID = (id: number) => {
    return {
        type: ADD_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const removeActiveTastesID = (id: number) => {
    return {
        type: REMOVE_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const setActiveHardnessId = (id: number) => {
    return {
        type: SET_ACTIVE_HARDNESS,
        payload: id,
    };
};

const removeActiveHardnessId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_HARDNESS,
        payload: id,
    };
};

const setActiveBrandsId = (id: number) => {
    return {
        type: ADD_ACTIVE_BRANDS_ID,
        payload: id,
    };
};

export const removeActiveBrandsId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_BRANDS_ID,
        payload: id,
    };
};

export const setIsLoadingTrue = () => async (dispatch: Dispatch) => {
   dispatch({
       type: SET_LOADING_TRUE
   })
};

export const getUserPreference = () => async (dispatch: Dispatch) => {
    dispatch({type: GET_USER_PREFERENCES_START});
    AccountAPI.getAccountPreferences()
        .then(res => dispatch({
            type: GET_USER_PREFERENCES_SUCCESS,
            payload: [res.hardness, res.brandIds, res.tasteIds]
        }))
        .catch(e => console.log(e));
};

export const handleTastesId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeTastesId = getState().changePreferences.activeTastesId;
    if (activeTastesId.length) {
        activeTastesId.findIndex((item: number) => item === id) === -1
            ? dispatch(addActiveTastesID(id))
            : dispatch(removeActiveTastesID(id));

    } else {
        dispatch(addActiveTastesID(id));
    }
};

export const handleHardnessId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeHardness = getState().changePreferences.activeHardnessId;
    activeHardness === null || activeHardness !== id
        ? dispatch(setActiveHardnessId(id))
        : dispatch(removeActiveHardnessId(id));
};

export const handleBrandsId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const handleBrandsId = getState().changePreferences.activeBrandsId;
    if (handleBrandsId.length) {
        handleBrandsId.findIndex((item: number) => item === id) === -1
            ? dispatch(setActiveBrandsId(id))
            : dispatch(removeActiveBrandsId(id));

    } else {
        dispatch(setActiveBrandsId(id));
    }
};

export const sendUserPreferences = () => async (dispatch: Dispatch, getState: () => any) => {
    const preferencesState = getState().changePreferences;
    AccountAPI.updateAccountPreferences(
        preferencesState.activeBrandsId,
        preferencesState.activeHardnessId,
        preferencesState.activeTastesId)
        .then(res => res)
        .catch(e => console.log(e));
};

const ChangePreferencesReducer = (state = inititalState, action: IChangePreferencesAction): IChangePreferencesState => {
    switch (action.type) {

        case ADD_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: [...state.activeTastesId, action.payload]
            }
        }

        case REMOVE_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: state.activeTastesId.filter((item: number) => item !== action.payload)
            }
        }

        case SET_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: action.payload
            }
        }

        case REMOVE_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: null,
            }
        }

        case ADD_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: [...state.activeBrandsId, action.payload]
            }
        }

        case REMOVE_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: state.activeBrandsId.filter((item: number) => item !== action.payload)
            }
        }


        case GET_USER_PREFERENCES_START: {
            return {
                ...state,
                isLoading: true
            };
        }

        case GET_USER_PREFERENCES_SUCCESS: {
            return {
                ...state,
                activeHardnessId: action.payload[0],
                activeBrandsId: action.payload[1],
                activeTastesId: action.payload[2],
                isLoading: false
            }
        }

        case SET_LOADING_TRUE: {
            return {
                ...state,
                isLoading: true
            }
        }

        default:
            return state;
    }
};

export default ChangePreferencesReducer;
